import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'qs';

import { fetchSqlReports } from 'actions/sqlReports';
import {
  getSqlReports,
  getPageCount,
  getLoggedInUser,
  getIncludedInGroups,
} from 'reducers';

const withSqlReports = (DecoratedComponent) => {
  class WithSqlReports extends Component {
    state = {
      loading: false,
    };

    componentDidMount() {
      this.fetchReports();
    }

    componentDidUpdate(oldProps) {
      const { page } = this.props;
      if (oldProps.page !== page) {
        this.fetchReports();
      }
    }

    fetchReports() {
      const { fetchSqlReports, page } = this.props;
      this.setState({ loading: true });
      fetchSqlReports(page).finally(() => this.setState({ loading: false }));
    }

    render() {
      const { children, ...props } = this.props;
      const { loading } = this.state;
      const childProps = {
        loading,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  const mapStateToProps = (state, { location: { search } }) => {
    const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });
    const sqlReports = getSqlReports(state, page);
    const isAdminOrManager = getIncludedInGroups(state, ['ADMIN', 'MANAGER']);
    const loggedInUser = getLoggedInUser(state);

    return {
      sqlReports,
      pageCount: getPageCount(state, 'sqlReports', 'fetchSqlReports_', page),
      page,
      isAdminOrManager,
      loggedInUser,
    };
  };

  const mapDispatchToProps = {
    fetchSqlReports,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithSqlReports);
};

export default withSqlReports;
